/* ============================================================
   MC COLLECTION PILLS — horizontal collection-pill rail
   Edge-aware overlaid prev/next arrows that fade out at the ends
   and auto-hide when nothing overflows. Mirrors the reference
   pages.js initRail() sync() + .qt-arrow:disabled behaviour.
   Guarded singleton; safe to include from multiple sections.
   ============================================================ */
(function () {
  'use strict';
  if (window.__mcPillsInit) return;
  window.__mcPillsInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function step(rail) {
    var item = rail.querySelector('.mc-collection-pills__pill') || rail.firstElementChild;
    if (!item) return rail.clientWidth * 0.8;
    var cs = window.getComputedStyle(rail);
    var gap = parseFloat(cs.columnGap || cs.gap) || 12;
    return item.getBoundingClientRect().width + gap;
  }

  function initWrap(wrap) {
    var rail = wrap.querySelector('[data-mc-pills-rail]');
    if (!rail) return;
    var prev = wrap.querySelector('[data-mc-pills-prev]');
    var next = wrap.querySelector('[data-mc-pills-next]');

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(rail), behavior: reduce ? 'auto' : 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(rail), behavior: reduce ? 'auto' : 'smooth' });
      });
    }

    rail.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);

    /* Bring the active pill into view if it starts off-screen */
    var active = rail.querySelector('.mc-collection-pills__pill.is-active');
    if (active && active.offsetLeft > rail.clientWidth) {
      rail.scrollLeft = active.offsetLeft - 24;
    }

    sync();
  }

  function init() {
    document.querySelectorAll('[data-mc-pills]').forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
